import { render } from "./brandList.vue?vue&type=template&id=195a1293"
import script from "./brandList.vue?vue&type=script&lang=js"
export * from "./brandList.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/brand/brandList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "195a1293"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('195a1293', __exports__)) {
    console.log('reload')
    api.reload('195a1293', __exports__)
  }
  
  module.hot.accept("./brandList.vue?vue&type=template&id=195a1293", () => {
    console.log('re-render')
    api.rerender('195a1293', render)
  })

}


export default __exports__